import { createFromIconfontCN } from '@ant-design/icons-vue'

export const IconFont = createFromIconfontCN({
  scriptUrl: '//at.alicdn.com/t/c/font_4262257_r7p96i0ch3.js',
})
